<template>
	<article class="team">
		<h1>Meet the Team</h1>
		<div class="content">
			<p>
				If you are looking for reliable and expert web development services then you are in the right place.
				Our expert team of web developers are ready to work together.
				<!--and help you reach your business goals.-->
			</p>
			<ul class="media-list team-list">
				<li class="media media-success media-default">
					<div class="media-left">
						<a href="#">
							<img class="media-object" src="static/images/team/chen.jpg" alt="Web Development and Consulting">
						</a>
					</div>
					<div class="media-body">
						<h4 class="media-heading">Chen Koifman</h4>
						Founder & Leader Web Developer
						<p>
							<small>
								Over 15 years of experience as a leader web developer/JS expert.<br/>
								In his resume some of the world's most influential organizations (SAP, Nice, AVG, Cellebrite) and Israeli leading companies (Migdal, Wallashops, Sela, Code Oasis).<br/>
								My expertise is focused on web development using: Angular, Redux, Node.js, Express, Vue.js, Webpack, ES6 and more...
							</small>
						</p>
					</div>
				</li>
			</ul>
			<p><small>Want to join our team? Visit our <router-link to="careers">careers page</router-link> for more details!</small></p>
		</div>

	</article>
</template>

<script>
	export default {
		name: 'team',
		data () {
			return {
			}
		}
	}
</script>

<style scoped>
	.team-list .media-left .media-object { width:100px; height:100px; }
	.team-list .media-body small { color:#777; }
</style>



// WEBPACK FOOTER //
// team.vue?3d0ca798